"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_js_1 = require("./index.js");
(0, index_js_1.registerIcon)('arrow-left', [{ tag: 'path', att: { 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', d: 'm3.999 11.9997 8 8.0011 1.4143-1.4141-5.5859-5.5866H20v-2H7.8273l5.5871-5.5868-1.4142-1.4143-8.0012 8.0007z' } }]);
